import React, { useCallback, useEffect, useState, useMemo } from "react";
import screenPermissions from "../consts/screenPermissions";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Space,
  Table,
  Tree,
  Card,
  Row,
  Col,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";
import moment from "moment";
import { AiOutlineUnlock, AiFillDelete } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";
import { roleActions } from "../store";
import roleApi from "../api/roleApi";
import debounce from "lodash.debounce";
import PERMISSION from "../consts/permissions";

const RoleManager = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { permissions } = useSelector((x) => x.auth);
  const [listPermissions, setPermissions] = useState(permissions);

  const { lstRolesPaging, totalCount } = useSelector((x) => x.role);

  const [loading, setLoading] = useState(false);
  const [isModalEditContractVisible, setIsModalEditContractVisible] =
    useState(false);

  //   const lstRoles = useSelector((x) => x.role.roles);

  const [btnDeleted, setBtnDeleted] = useState(false);
  const [listDeleted, setListDeleted] = useState([]);
  const [titleModal, setTitleModal] = useState("");
  const [isEditModal, setEditModal] = useState(false);
  const [valueFormUser, setValueFormUser] = useState();
  const [inputFilter, setFilter] = useState({
    name: "",
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const dateFormat = "DD/MM/YYYY HH:mm:ss";

  useEffect(() => {
    getRolesPaging();
    getRoles();
    form.setFieldsValue(valueFormUser);
  }, [inputFilter, form, valueFormUser, isEditModal]);

  const getRolesPaging = () => {
    onSelectChange([], []);
    setLoading(true);
    dispatch(roleActions.getRolesPaging(inputFilter)).then(() => {
      setLoading(false);
    });
  };

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, page: 1,name: e.target.value });
  };

  const getRoleDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getRoles = () => {
    dispatch(roleActions.getAll());
  };

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Tên quyền",
      dataIndex: "name",
      render: (text) => <h6>{text}</h6>,
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdAt",
      render: (createdAt) => <>{moment(createdAt).format(dateFormat)} </>,
    },
    {
      title: "Ngày sửa cuối",
      dataIndex: "updatedAt",
      render: (updatedAt) => <>{moment(updatedAt).format(dateFormat)} </>,
    },
    {
      title: "Quyền hạn",
      dataIndex: "permissions",
      // render: (_, { permissions }) => (
      //   <>
      //     {permissions.map((permission) => {
      //       return <Tag key={permission}>{permission}</Tag>;
      //     })}
      //   </>
      // ),
      hidden: true,
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {listPermissions.includes(PERMISSION.Admin_Role_Update) ? (
            <>
              <Button
                onClick={() => showEditModal(record)}
                value="large"
                icon={<EditOutlined />}
              >
                Sửa
              </Button>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Role_Delete) ? (
            <>
              <Button
                value="large"
                type="primary"
                icon={<DeleteOutlined />}
                danger
                onClick={() => deleteRole(record)}
              >
                Xóa
              </Button>
            </>
          ) : null}
        </Space>
      ),
      width: 150,
      className: "text-center",
    },
  ].filter((item) => !item.hidden);

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      name: inputFilter.name,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    // console.log(
    //   `selectedRowKeys: ${newSelectedRowKeys}`,
    //   "selectedRows: ",
    //   selectedRows
    // );
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const confirm = Modal.confirm;

  const deleteRole = (record) => {
    confirm({
      title: "Bạn có muốn xóa quyền này không?",
      onOk() {
        roleApi
          .deleteRole(record.id)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công quyền ");
              getRolesPaging();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteRoles = () => {
    const data = {
      roleIds: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các quyền này không?",
      onOk() {
        roleApi
          .deleteRoles(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công các quyền ");
              getRolesPaging();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const showEditModal = (record) => {
    setEditModal(true);
    setTitleModal("Sửa thông tin tài khoản");

    setValueFormUser({
      id: record.id,
      name: record.name,
      // permissions: record.permissions,
    });
    setCheckedKeys(record.permissions);
    setIsModalEditContractVisible(true);
  };

  const showCreateModal = () => {
    setTitleModal("Thêm quyền");
    setValueFormUser({
      id: null,
      name: null,
      permissions: [],
    });
    setEditModal(false);
    setCheckedKeys([]);
    setExpandedKeys([]);
    setSelectedKeys([]);
    setAutoExpandParent(false);
    setIsModalEditContractVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateRole(values);
      } else {
        createRole(values);
      }
    },
    [isEditModal, checkedKeys]
  );

  const createRole = (data) => {
    if (checkedKeys.length <= 0) {
      Swal.fire({
        title: "Thất bại!",
        text: "Vui lòng chọn permissions!",
        icon: "warning",
        confirmButtonText: "OK",
      });
    } else {
      const payload = {
        name: data.name,
        description: "role description",
        permissions: checkedKeys,
      };
      roleApi.createRole(payload).then(
        (res) => {
          console.log("res", res);
          if (!res.code) {
            Swal.fire({
              title: "Thành Công!",
              text: "Thêm quyền thành công!",
              icon: "success",
              confirmButtonText: "OK",
            });
            setIsModalEditContractVisible(false);
            getRolesPaging();
          } else {
            Swal.fire({
              title: "Thất bại!",
              text: res.message,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        },
        (err) => {
          console.log("err", err);
          Swal.fire({
            title: "Thất bại!",
            text: err.response?.data?.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
    }
  };

  const updateRole = (data) => {
    if (checkedKeys.length <= 0) {
      Swal.fire({
        title: "Thất bại!",
        text: "Vui lòng chọn permissions!",
        icon: "warning",
        confirmButtonText: "OK",
      });
    } else {
      const payload = {
        name: data.name,
        permissions: checkedKeys,
      };
      roleApi.updateRole(data.id, payload).then(
        (res) => {
          console.log("res", res);
          if (!res.code) {
            Swal.fire({
              title: "Thành Công!",
              text: "Sửa quyền thành công!",
              icon: "success",
              confirmButtonText: "OK",
            });
            setIsModalEditContractVisible(false);
            getRolesPaging();
          } else {
            Swal.fire({
              title: "Thất bại!",
              text: res.message,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        },
        (err) => {
          console.log("err", err);
          Swal.fire({
            title: "Thất bại!",
            text: err.response?.data?.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
    }
  };

  const closePopup = useCallback(() => {
    setValueFormUser({
      id: null,
      name: null,
      permissions: [],
    });
    form.resetFields();
    setCheckedKeys([]);
    setExpandedKeys([]);
    setSelectedKeys([]);
    setAutoExpandParent(false);
    setIsModalEditContractVisible(false);
  }, [form]);

  const onExpand = (expandedKeysValue) => {
    // console.log("onExpand", expandedKeysValue);
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  // const onCheck = useCallback((checkedKeysValue) => {
  //   console.log("onCheck", checkedKeysValue);
  //   setCheckedKeys(checkedKeysValue);
  // }, [checkedKeys]);

  const onCheck = (checkedKeysValue) => {
    console.log("onCheck", checkedKeysValue);
    setCheckedKeys(checkedKeysValue);
  };

  const onSelect = (selectedKeysValue, info) => {
    // console.log("onSelect", info);
    setSelectedKeys(selectedKeysValue);
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={24}>
            <Col span={24}>
              <label> Tìm theo quyền</label>
              <Input
                addonAfter={<SearchOutlined />}
                placeholder="Nhập tên role..."
                defaultValue={inputFilter.name}
                onChange={getRoleDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
            {/* <Col span={6}>
              <label className="" style={{ color: "#7c7c7c" }}>
                <strong>Lọc theo quyền:</strong>{" "}
              </label>

              <Select
                value={inputFilter.name}
                defaultValue=""
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                onChange={(e) => {
                  setFilter({ ...inputFilter, name: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                {lstRoles == null || lstRoles === "undefined" || lstRoles === []
                  ? []
                  : lstRoles.map((item, key) => (
                      <Option key={key} value={item.name}>
                        {item.name}
                      </Option>
                    ))}
              </Select>
            </Col> */}
          </Row>
        </Card>
        <br />
        <Space size={10}>
          {listPermissions.includes(PERMISSION.Admin_Role_Create) ? (
            <>
              <Button
                type="dashed"
                onClick={() => showCreateModal()}
                size="small"
              >
                <EditOutlined /> &nbsp; Thêm quyền
              </Button>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Role_Delete) ? (
            <>
              {btnDeleted ? (
                <Button
                  value="small"
                  type="primary"
                  icon={<AiFillDelete />}
                  danger
                  onClick={() => {
                    deleteRoles();
                  }}
                >
                  &nbsp; Xóa các tài khoản được chọn
                </Button>
              ) : null}
            </>
          ) : null}
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstRolesPaging}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>

        <Modal
          title={titleModal}
          visible={isModalEditContractVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
        >
          <div>
            <Form
              initialValues={valueFormUser}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item hidden={true} label="Id" name="id">
                <Input />
              </Form.Item>

              <Form.Item
                label="Tên quyền"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập tên tài khoản!",
                  },
                ]}
              >
                <Input
                  
                  addonAfter={<AiOutlineUnlock />}
                  placeholder="Nhập tên quyền..."
                />
              </Form.Item>

              <Form.Item
                label={
                  <label>
                    <span style={{ color: "#ff4d4f" }}>*</span> Quyền hạn
                  </label>
                }
                name="permissions"
                // rules={[
                //   {
                //     required: true,
                //     message: "Vui lòng chọn permissions!",
                //   },
                // ]}
              >
                <Tree
                  checkable
                  onExpand={onExpand}
                  expandedKeys={expandedKeys}
                  autoExpandParent={autoExpandParent}
                  onCheck={onCheck}
                  checkedKeys={checkedKeys}
                  onSelect={onSelect}
                  selectedKeys={selectedKeys}
                  treeData={screenPermissions}
                />
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default RoleManager;
